import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3c3ee3e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c3c3ee3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c3ee3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c3ee3e')) {
      api.createRecord('c3c3ee3e', component.options)
    } else {
      api.reload('c3c3ee3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3c3ee3e&scoped=true&", function () {
      api.rerender('c3c3ee3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/base-table/index.vue"
export default component.exports